import React, { useMemo, useState, useEffect, useRef } from "react";
import {
  getData,
  columns,
  formatRowData,
  invoiceInsideColumns,
} from "./PastPaymentsData";
import MockData from "./PastPaymentInvoicesMockData.json";
import lawyerdropdownMockResponse from "../orderStatus/lawyerdropdownmockresponse.json";
import { OrderStatusConstants, InvoiceConstants } from "../../common/constants";
import { useTranslation } from "react-i18next";
import AppTable from "../orderStatus/AppTable";
import Pagination from "../orderStatus/Pagination";
import PaymentSummary from "./PaymentSummary";
import InvoicesFilter from "./InvoicesFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCCtransactionInvoices,
  GetChequeTransactionInvoices,
  GetEFTTransactionInvoices,
  GetPreAuthorizedTransactionInvoices,
  invoiceSelector,
  setInvoiceFilterValue,
  setSelectedPastPayments,
} from "../../features/invoice/invoiceSlice";
import Loader from "../orderStatus/Loader";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { exportRowToCSV } from "../../common/utils";
import moment from "moment";
import { lawFirmSelector } from "../../features/lawFirm/lawFirmSlice";

const PastPayments = ({
  setshowOutstanding,
  pastPayments,
  getPastPayments,
  isLawyer,
  isInternalUser,
}) => {
  const pastPaymentsData = pastPayments;
  const isFirstRender = useRef(true);
  // Object.values(MockData.PastPayments).flat(1);
  const { lawyerFilterOptions, loadingInvoice, loadingPayments, error } =
    useSelector(invoiceSelector);
  const { userLogin } = useSelector(authLoginSelector);
  const dispatch = useDispatch();
  const [column, setColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalOrders: pastPaymentsData?.length,
    column: null,
    order: "ascending",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  const [PaymentData, setPaymentData] = useState(null);

  const columns = () => {
    return [
      {
        Header: t("PaymentDate"),
        accessor: "paymentDate",
        width: 30,
      },

      {
        Header: t("PaymentMethod"),
        accessor: "paymentMethod",
        width: 200,
      },
      {
        Header: t("PaymentTotal"),
        accessor: "paymentTotal",
        width: 0,
        Cell: ({ row }) => {
          return (
            <div className="ml-3 w-max">
              <span className="">{row.original.paymentTotal}</span>
            </div>
          );
        },
      },
      {
        Header: t("Download"),
        width: 100,
        Cell: ({ row }) => {
          return (
            <div className="w-max">
              <button
                className="text-secondary-blue"
                onClick={async () => {
                  const paymentID = row?.original?.paymentID;
                  const invoiceDetailsData = await dispatch(
                    row?.original?.paymentMethod?.includes("Credit Card")
                      ? GetCCtransactionInvoices(userLogin?.userId, paymentID)
                      : row?.original?.paymentMethod?.includes("Cheque")
                        ? GetChequeTransactionInvoices(
                          userLogin?.userId,
                          paymentID,
                        )
                        : row?.original?.paymentMethod?.includes("EFT")
                          ? GetEFTTransactionInvoices(
                            userLogin?.userId,
                            paymentID,
                          )
                          : GetPreAuthorizedTransactionInvoices(
                            userLogin?.userId,
                            paymentID,
                          ),
                  );
                  exportRowToCSV(row.original, invoiceDetailsData, "", t);
                }}
              >
                {t("Download")}
              </button>
            </div>
          );
        },
      },
    ];
  };
  const runFetch = (pageNumber) => {
    setPageData((prevState) => ({
      ...prevState,
      rowData: [],
      isLoading: true,
    }));
    if (filterValues) {
      let datestart =
        (Array.isArray(filterValues?.closingDate) &&
          filterValues?.closingDate?.length > 0 &&
          filterValues.closingDate[0] !== "" &&
          moment(filterValues.closingDate[0]).format("MM/DD/YYYY")) ||
        "";
      let dateend =
        (Array.isArray(filterValues?.closingDate) &&
          filterValues?.closingDate?.length > 0 &&
          filterValues.closingDate[0] !== "" &&
          moment(filterValues.closingDate[1]).format("MM/DD/YYYY")) ||
        "";
      getPastPayments({
        lawyerID: filterValues?.LawyerName,
        dateRangeStart: datestart,
        dateRangeEnd: dateend,
        paymentMethod: filterValues?.paymentMethod || "",
        searchText: filterValues?.search || "",
        sortColumn: column || "",
        sortOrder: sortOrder || "",
        totalRangeStart:
          (filterValues?.rangeValue?.length > 0 &&
            filterValues?.rangeValue[0]) ||
          null,
        totalRangeEnd:
          (filterValues?.rangeValue?.length > 0 &&
            filterValues?.rangeValue[1]) ||
          null,
        pageNumber,
      });
      dispatch(setInvoiceFilterValue(["PastPayments", filterValues]));
    }
  };
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setCurrentPage(0); // reset pagination
    runFetch(1); // always page 1 on filter/sort change
  }, [column, sortOrder, filterValues]);

  useEffect(() => {
    if (isFirstRender.current) return;
    runFetch(currentPage + 1); // pagination-driven fetch
  }, [currentPage]);
  useEffect(
    () =>
      setPageData({
        isLoading: false,
        rowData: pastPaymentsData,
        totalPages: Math.ceil(
          pastPaymentsData &&
          pastPaymentsData?.length > 0 &&
          pastPaymentsData[0]?.totalRows / 10,
        ),
        totalOrders:
          pastPaymentsData &&
          pastPaymentsData?.length > 0 &&
          pastPaymentsData[0]?.totalRows,
      }),
    [pastPaymentsData],
  );
  const onSort = (column, order) => {
    setPageData((prevState) => ({
      ...prevState,
      column,
      order,
    }));
    setColumn(column);
    setSortOrder(order);
  };

  const { t } = useTranslation();
  const { lawyersByFirm } = useSelector(lawFirmSelector);
  const DealTypeOptions = OrderStatusConstants.DealTypeOptions.map(
    (item, i) => {
      return { label: t(item.label), value: item.value };
    },
  );
  const StatusOptions = OrderStatusConstants.StatusOptions.map((item, i) => {
    return { label: t(item.label), value: item.value };
  });

  const LawyerOptions = [
    { label: "All", value: "All" },
    ...(lawyerFilterOptions?.map((item) => ({
      label: t(item.lawyerWithActive),
      value: item.userId,
    })) || []),
  ];
  const PaymentMethodOptions = InvoiceConstants.PastPaymentMethodOptions.map(
    (item, i) => {
      return { label: t(item.label), value: item.value };
    },
  );

  const [LawyerOptionsByFirm, setLawyerOptionsbyFirm] = useState([]);

  useEffect(() => {
    if (lawyerFilterOptions === undefined || lawyerFilterOptions === null || lawyerFilterOptions?.length === 0) {
      let lawyeroptions = [];
      lawyeroptions.push({ label: t('All'), value: "All" });
      lawyersByFirm?.lawyers?.map((item, i) => {
        lawyeroptions.push({ label: t(item.lawyer), value: item.userID });
      });
      setLawyerOptionsbyFirm(lawyeroptions);
    }

  }, [lawyersByFirm]);

  return (
    <div>
      {!PaymentData && (
        <>
          <InvoicesFilter
            DealTypeOptions={DealTypeOptions}
            LawyerOptions={lawyerFilterOptions?.length ? LawyerOptions : LawyerOptionsByFirm}
            StatusOptions={StatusOptions}
            onFilter={(values) => {
              if (isFirstRender.current) {
                isFirstRender.current = false;
                return;
              }
              setFilterValues((prev) => ({ ...prev, ...values }));
            }}
            isPastPayment
            PaymentMethodOptions={PaymentMethodOptions}
            isLawyer={isLawyer}
            isInternalUser={isInternalUser}
          />

          <div style={{ height: "auto" }} className="pt-2">
            {pageData?.rowData !== null && (
              <AppTable
                columns={columns}
                data={pageData.rowData}
                isLoading={pageData.isLoading}
                onSort={onSort}
                manualSorting
                isPastPayments={true}
                invoiceInsideColumns={invoiceInsideColumns}
                setSelectedRows={(rows) => {
                  dispatch(
                    setSelectedPastPayments(rows?.map((item) => item.original)),
                  );
                }}
              />
            )}
          </div>
          <br />
          {!pageData.rowData ||
            (pageData?.rowData?.length === 0 && (
              <div className="text-center text-secondary-red font-semibold text-lg">
                {t("noResults")}
              </div>
            ))}
          <br />
          <div>
            <Pagination
              totalRows={pageData.totalOrders}
              pageChangeHandler={(page) => {
                if (isFirstRender.current) {
                  isFirstRender.current = false;
                  return;
                } else setCurrentPage(page);
              }}
              rowsPerPage={10}
              currentPage={currentPage}
            />
          </div>
        </>
      )}
      {PaymentData && (
        <PaymentSummary
          setPaymentData={setPaymentData}
          InvoiceDetails={PaymentData}
          setshowOutstanding={setshowOutstanding}
        />
      )}

      {loadingInvoice ? <Loader /> : ""}
    </div>
  );
};

export default PastPayments;
